import { useState } from 'react';
import Navbar from '../components/Navbar';
import ProductModal from '../components/ProductModal';
import '../components/productos.css';

import imgCintas from '../assets/images/cinta.png';
import imgRollo from '../assets/images/rollo.png';
import imgEmpaques from '../assets/images/empaques.png';

import { Link } from 'react-router-dom';

function Productos() {

  const [productoActivo, setProductoActivo] = useState(null);

  const productos = [
    {
      tipo: 'papel',
      titulo: 'CINTAS DE PAPEL',

      imagen: imgCintas,
      imagenes: [imgCintas, imgRollo, imgEmpaques],

      descripcion: 'Cinta de papel kraft resistente, ideal para procesos industriales.',

      usos: ['Tubos de cartón', 'Esquineros', 'Encuadernación'],

      presentacion: 'Bobina',
      gramaje: '60 - 100 g/m²',
      dimensiones: 'Variables',
      peso: 'Según producción',

      caracteristicas: [
        { titulo: 'Material', valor: 'Papel kraft' },
        { titulo: 'Resistencia', valor: 'Alta tracción' },
        { titulo: 'Flexibilidad', valor: 'Alta' },
        { titulo: 'Ecológico', valor: 'Reciclable' }
      ],

      // 🔥 FICHA TÉCNICA (CINTAS)
      fichaTecnica: {
        headers: ['Propiedad', 'Método', 'Rango', 'CT180', 'CT200', 'CT300'],
        rows: [
          {
            propiedad: 'Peso Base',
            metodo: 'TAPPI T410',
            valores: [
              ['Max', 189, 210, 315],
              ['Std', 180, 200, 300],
              ['Min', 171, 190, 285]
            ]
          },
          {
            propiedad: 'Calibre',
            metodo: 'TAPPI T411',
            valores: [
              ['Max', 0.34, 0.41, 0.57],
              ['Std', 0.31, 0.37, 0.54],
              ['Min', 0.29, 0.33, 0.52]
            ]
          },
          {
            propiedad: 'Tensil MD',
            metodo: 'ISO 1924-2',
            valores: [
              ['Std', 30, 33, 50],
              ['Min', 28, 31, 48]
            ]
          }
        ]
      }
    },

    {
      tipo: 'papel',
      titulo: 'ROLLO DE PAPEL',

      imagen: imgRollo,
      imagenes: [imgRollo, imgCintas],

      descripcion: 'Rollos industriales para procesos productivos y logísticos.',

      usos: ['Empaque', 'Protección', 'Industria'],

      presentacion: 'Bobinas',
      gramaje: '50 - 120 g/m²',
      dimensiones: 'Diferentes anchos',
      peso: 'Variable',

      caracteristicas: [
        { titulo: 'Material', valor: 'Kraft natural' },
        { titulo: 'Resistencia', valor: 'Alta' },
        { titulo: 'Formato', valor: 'Continuo' }
      ],

      // 🔥 FICHA TÉCNICA (ROLLO)
      fichaTecnica: {
        headers: ['Propiedad', 'Método', 'Rango', 'OS115', 'OS130', 'OS150', 'OS180', 'OS200', 'OS220', 'OS250'],
        rows: [
          {
            propiedad: 'Peso Base (g/m²)',
            metodo: 'TAPPI T410',
            valores: [
              ['Max', 121, 137, 158, 189, 210, 231, 263],
              ['Std', 115, 130, 150, 180, 200, 220, 250],
              ['Min', 109, 124, 143, 171, 190, 209, 238]
            ]
          },
          {
            propiedad: 'RCT (lbf)',
            metodo: 'TAPPI T822',
            valores: [
              ['Std', 32, 36, 42, 50, 56, 62, 70],
              ['Min', 27, 31, 37, 45, 51, 57, 65]
            ]
          },
          {
            propiedad: 'CFC-O (lbf)',
            metodo: '',
            valores: [
              ['Std', 50, 58, 68, 80, 85, 95, 108],
              ['Min', 45, 53, 63, 75, 80, 90, 103]
            ]
          },
          {
            propiedad: 'CMT (lbf)',
            metodo: 'TAPPI T809',
            valores: [
              ['Std', 43, 48, 56, 63, 70, 77, 88],
              ['Min', 38, 43, 51, 58, 65, 72, 83]
            ]
          },
          {
            propiedad: 'SCT CD (lb/in)',
            metodo: 'TAPPI T826',
            valores: [
              ['Std', 10.4, 11.7, 13.5, 16.2, 18.0, 19.8, 22.5],
              ['Min', 9.4, 10.7, 12.5, 15.2, 17.0, 18.8, 21.5]
            ]
          },
          {
            propiedad: 'SCT MD (lb/in)',
            metodo: 'TAPPI T826',
            valores: [
              ['Std', 21.9, 24.7, 28.5, 34.2, 38.0, 41.8, 47.5],
              ['Min', 19.9, 22.7, 26.5, 32.2, 36.0, 39.8, 45.5]
            ]
          }
        ]
      }
    },

    {
      tipo: 'caja',
      titulo: 'EMPAQUES',

      imagen: imgEmpaques,
      imagenes: [imgEmpaques, imgCintas],

      descripcion: 'Soluciones de empaque en cartón corrugado para logística y transporte.',

      usos: ['Logística', 'Almacenamiento', 'Transporte'],

      presentacion: 'Cajas',
      gramaje: 'Variable',
      dimensiones: 'Personalizadas',
      peso: 'Depende del diseño',

      caracteristicas: [
        { titulo: 'Cajas regulares', valor: 'Uso estándar' },
        { titulo: 'Cajas pizza', valor: 'Mantienen temperatura' },
        { titulo: 'Cajas especiales', valor: 'Diseño a medida' }
      ]

      // 🔥 AQUÍ LUEGO METES LA FICHA DE EMPAQUES
    }
  ];

  return (
    <>
      <Navbar />

      <div className="productos-pro">

        <h2 className="productos-title">Nuestras soluciones</h2>

        <p className="productos-subtitle">
          Soluciones en papel y empaques diseñadas para la industria y logística.
        </p>

        {productos.map((p, i) => (
          <div 
            key={i}
            className={`producto-item ${i % 2 !== 0 ? 'reverse' : ''}`}
            onClick={() => {
              console.log('CLICK OK');
              setProductoActivo(p);
            }}
          >

            <div className="producto-img">
              <img src={p.imagen} alt={p.titulo} />
            </div>

            <div className="info">
              <h3>{p.titulo}</h3>
              <p>{p.descripcion}</p>

              <ul>
                {p.usos.map((uso, index) => (
                  <li key={index}>{uso}</li>
                ))}
              </ul>

              <button 
                className="btn-ver"
                onClick={(e) => {
                  e.stopPropagation();
                  setProductoActivo(p);
                }}
              >
                Ver detalle
              </button>
            </div>
          </div>
        ))}

        {/* BENEFICIOS */}
        <div className="productos-beneficios">
          <div>
            <h4>♻️ Sostenibilidad</h4>
            <p>Materiales reciclables y amigables con el ambiente.</p>
          </div>

          <div>
            <h4>🏭 Producción</h4>
            <p>Alta capacidad para procesos industriales.</p>
          </div>

          <div>
            <h4>⚙️ Personalización</h4>
            <p>Soluciones adaptadas a cada cliente.</p>
          </div>
        </div>

        {/* CTA */}
        <div className="productos-cta">
          <h3>¿Necesitas una solución a medida?</h3>
          <p>Contáctanos y recibe asesoría personalizada.</p>

          <Link to="/contacto" className="btn-contactoP">
            Contáctanos
          </Link>
        </div>

      </div>

      <ProductModal 
        producto={productoActivo} 
        onClose={() => setProductoActivo(null)} 
      />
    </>
  );
}

export default Productos;